// LegalDetailsSlice.js

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  legalDetails: [],
};


const legalDetailsSlice = createSlice({
  name: "legalDetails",
  initialState,
  reducers: {
    updateLegalDetails: (state, action) => {
      const updatedDetails = action.payload;
      const existingDetailsIndex = state.legalDetails.findIndex(
        (detail) => detail.deal_id === updatedDetails.deal_id
      );

      if (existingDetailsIndex !== -1) {
        state.legalDetails[existingDetailsIndex] = updatedDetails;
      }
    },
    deleteLegalDetails: (state, action) => {
      const dealIdToDelete = action.payload;
      state.legalDetails = state.legalDetails.filter(
        (detail) => detail.deal_id !== dealIdToDelete
      );
    },
    resetLegalDetails: (state) => {
      state.legalDetails = [];
    },
  },

});

export const { updateLegalDetails, deleteLegalDetails, resetLegalDetails } =
  legalDetailsSlice.actions;
export default legalDetailsSlice.reducer;
